import { resourceCache } from "@/cache/resourceCache";

export const COMPANY_WISHLIST_CACHE_KEY = "company-wishlist-overview:v2";

export function invalidateCompanyWishlistCache(
  ownerId: string | null | undefined,
): boolean {
  if (!ownerId) return false;
  resourceCache.invalidate(ownerId, COMPANY_WISHLIST_CACHE_KEY);
  return true;
}
